var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.download !== undefined
    ? _c("div", { staticClass: "download-container" }, [
        _c("div", [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "group-container" },
            _vm._l(this.inputs, function(group) {
              return _c(
                "div",
                { staticClass: "group" },
                _vm._l(group.items, function(input, key) {
                  return _c(
                    "div",
                    { staticClass: "option" },
                    [
                      _vm._l(input.values, function(radio) {
                        return input.type == "radio"
                          ? _c(
                              "div",
                              {
                                staticClass: "radio-container",
                                class: { selected: input.selected },
                                on: {
                                  click: function($event) {
                                    return _vm.updateRadio(input, radio)
                                  }
                                }
                              },
                              [
                                _c("span", {
                                  staticClass: "radio",
                                  class: {
                                    selected: input.value == radio.value
                                  }
                                }),
                                _c("label", [_vm._v(_vm._s(radio.label))])
                              ]
                            )
                          : _vm._e()
                      }),
                      input.type == "checkbox"
                        ? _c(
                            "div",
                            {
                              staticClass: "checkbox-container",
                              on: {
                                click: function($event) {
                                  return _vm.updateCheckbox(input)
                                }
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "checkbox",
                                class: { selected: input.selected }
                              }),
                              _c("label", [_vm._v(_vm._s(input.label))])
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                }),
                0
              )
            }),
            0
          ),
          _vm.responseLogs
            ? _c("p", { staticClass: "error" }, [
                _c("strong", [_vm._v(_vm._s(_vm.responseLogs))])
              ])
            : _vm._e()
        ]),
        _c("div", { staticClass: "action" }, [
          _c(
            "div",
            {
              staticClass: "button confirm",
              class: { disabled: _vm.options == "" },
              on: { click: _vm.validate }
            },
            [_c("p", [_vm._v("Download")])]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          "Please select the differents options that you would like to include or exclude in your download."
        ),
        _c("br"),
        _vm._v(
          "\nAn archive will be generated to be used locally on your computer."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }